import { renderLucideIcon } from '../utils/lucide-icons.js'

function renderPopin(options) {
  options = options || {}
  var title = String(options.title || '').trim()
  var label = String(options.ariaLabel || title || 'Fenetre')
  var className = String(options.className || '').trim()
  var dialogClassName = String(options.dialogClassName || '').trim()
  var closeAttributes = String(options.closeAttributes || 'data-popin-close').trim()
  var head = options.header || ''
  var body = options.body || ''

  return (
    '<div class="wc-popin ' + escapeAttributeValue(className) + '">' +
      '<div class="wc-popin-backdrop" ' + closeAttributes + '></div>' +
      '<div class="wc-popin-dialog ' + escapeAttributeValue(dialogClassName) + '" role="dialog" aria-modal="true" aria-label="' + escapeAttributeValue(label) + '">' +
        '<div class="wc-popin-head">' +
          head +
          '<button type="button" class="wc-popin-close" ' + closeAttributes + ' aria-label="Fermer">' + renderLucideIcon('x') + '</button>' +
        '</div>' +
        body +
      '</div>' +
    '</div>'
  )
}

function escapeAttributeValue(value) {
  return String(value)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;')
    .replace(/`/g, '&#96;')
}

export { renderPopin }
